import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserGroup } from '@fortawesome/free-solid-svg-icons';
import '../css/ViewingGuestStrip.css';

const ViewingGuestStrip = ({ hostName = '' }) => (
  <h2 className="viewing-guest-strip">
    <span className="viewing-guest-strip__icon" aria-hidden="true">
      <FontAwesomeIcon icon={faUserGroup} />
    </span>
    <span>
      You are viewing a guest{hostName ? <> of <strong>{hostName}</strong></> : null}
    </span>
  </h2>
);

export default ViewingGuestStrip;
